import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { r } from '../../../shared/lib/responsive';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Viewport = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const Track = styled.ul`
  position: relative;
  width: 100%;
  ${r('height', 300)}
  margin: 0;
  padding: 0;
  list-style: none;
  touch-action: pan-y;
  cursor: grab;
  outline: none;
  user-select: none;
  -webkit-user-select: none;

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.7);
    ${r('border-radius', 8)}
  }

  &:active {
    cursor: grabbing;
  }
`;

export const Slide = styled.li<{ $active?: boolean; $hidden?: boolean }>`
  position: absolute;
  left: 50%;
  top: 0;
  display: flex;
  justify-content: center;
  ${r('width', 189)}
  transform-origin: center bottom;
  transition:
    transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    opacity 0.35s ease;
  cursor: pointer;

  ${(p) =>
    p.$active &&
    css`
      cursor: default;
    `}

  ${(p) =>
    p.$hidden &&
    css`
      pointer-events: none;
    `}
`;

export const Pagination = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--dot-gap);
  ${r('margin-top', -8)}
`;

export const Dot = styled.li<{ $active?: boolean }>`
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: 50%;
  background: var(--color-dot-inactive);
  transition: background 0.2s ease;

  ${(p) =>
    p.$active &&
    css`
      background: var(--color-dot-active);
    `}
`;
